import { NgModule } from '@angular/core';
import { AsyncAutocompleteMultipleSelectsComponent } from './async-autocomplete-multiple-selects.component';

@NgModule({
  imports: [AsyncAutocompleteMultipleSelectsComponent],
  exports: [AsyncAutocompleteMultipleSelectsComponent]
})
export class AsyncAutocompleteMultipleSelectsModule {}
